import { useState, useEffect } from 'react';

const useEnterKey = (inputs) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        const nextIndex = (currentIndex + 1) % inputs.length;
        inputs[nextIndex].focus();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [currentIndex, inputs]);

  const handleFocus = (index) => {
    setCurrentIndex(index);
  };

  return { handleFocus };
};

export default useEnterKey;